// Student Editor - PartCPage6 (Pixel-perfect redesign - Stage 2 editable learner reflection with stick figure)
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useActivityContext } from '../index';
import { API_CONFIG } from '../../../../../config/api';

const PartCPage6 = () => {
  const { activity } = useActivityContext();
  const [formData, setFormData] = useState({
    awareness: { item_1: false, item_2: false, item_3: false },
    sensitivity: { item_1: false, item_2: false, item_3: false },
    creativity: { item_1: false, item_2: false, item_3: false },
    self_appreciation: ''
  });
  const [saveMessage, setSaveMessage] = useState('');

  useEffect(() => {
    if (activity?.my_response_part_c?.page_6) {
      setFormData(activity.my_response_part_c.page_6);
    }
  }, [activity]);

  const saveChanges = async (data) => {
    try {
      const token = localStorage.getItem('accessToken');
      const apiUrl = API_CONFIG.BASE_URL;

      await axios.put(
        `${apiUrl}/secondary/user/domain-activities/${activity.activity_id}/part-c/page/6/student-fields`,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSaveMessage('Saved ✓');
      setTimeout(() => setSaveMessage(''), 2000);
    } catch (error) {
      console.error('Error:', error);
      setSaveMessage('Error');
    }
  };

  const handleCategoryChange = (category, field, value) => {
    const newFormData = { ...formData, [category]: { ...formData[category], [field]: value } };
    setFormData(newFormData);
    saveChanges(newFormData);
  };

  const handleFieldChange = (field, value) => {
    const newFormData = { ...formData, [field]: value };
    setFormData(newFormData);
    saveChanges(newFormData);
  };

  const calculateTotal = (category) => {
    const cat = formData[category];
    let total = 0;
    if (cat.item_1) total++;
    if (cat.item_2) total++;
    if (cat.item_3) total++;
    return total;
  };

  const renderCategory = (categoryName, title, items) => {
    const category = formData[categoryName];

    return (
      <div style={{ marginBottom: '12px' }}>
        <div style={{
          backgroundColor: '#4A90A4',
          color: 'white',
          padding: '6px 12px',
          fontWeight: 'bold',
          fontSize: '14px',
          marginBottom: '0'
        }}>
          {title}
        </div>
        <div style={{
          fontSize: '14px',
          padding: '10px 12px',
          backgroundColor: '#B3D9E8',
          minHeight: '80px'
        }}>
          {items.map((item, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
              <input
                type="checkbox"
                checked={category[`item_${index + 1}`]}
                onChange={(e) => handleCategoryChange(categoryName, `item_${index + 1}`, e.target.checked)}
                style={{
                  width: '16px',
                  height: '16px',
                  marginRight: '8px',
                  marginTop: '1px',
                  cursor: 'pointer',
                  flexShrink: 0
                }}
              />
              <span style={{ lineHeight: '1.4' }}>{item}</span>
            </div>
          ))}

          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginTop: '12px',
            paddingTop: '8px'
          }}>
            <span style={{ marginRight: '10px', fontWeight: 'bold', fontSize: '14px' }}>Total number of (✓):</span>
            <div style={{
              width: '35px',
              height: '35px',
              border: '3px solid #4A90A4',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '14px',
              backgroundColor: 'white'
            }}>
              {calculateTotal(categoryName)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{
      width: '100%',
      maxWidth: '1400px',
      minHeight: '80vh',
      margin: '0 auto',
      padding: '40px',
      backgroundColor: 'white',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      position: 'relative',
      fontFamily: "'Poppins', Arial, sans-serif"
    }}>
      {saveMessage && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          backgroundColor: saveMessage.includes('Error') ? '#f44336' : '#4caf50',
          color: 'white',
          padding: '8px 16px',
          borderRadius: '4px',
          zIndex: 1000
        }}>
          {saveMessage}
        </div>
      )}



      <div style={{
        fontSize: '14px',
        fontWeight: 'bold',
        marginBottom: '10px',
        textAlign: 'center',
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '8px'
      }}>
        Stage 2
      </div>

      <div style={{
        fontSize: '15px',
        fontWeight: 'bold',
        marginBottom: '12px',
        backgroundColor: '#4A90A4',
        color: 'white',
        padding: '6px 12px',
        display: 'inline-block'
      }}>
        Learner Reflection
      </div>

      <div style={{
        fontSize: '14px',
        marginBottom: '15px',
        padding: '0',
        fontWeight: 'bold',
        lineHeight: '1.5'
      }}>
        Tick (✓) all statements that apply.
      </div>

      {renderCategory('awareness', 'Awareness', [
        'I was able to identify and address the challenges that I had earlier anticipated.',
        'I was able to collect data from a sufficient number of respondents.',
        'I was able to refine and improve the draft through the course of the project.'
      ])}

      {renderCategory('sensitivity', 'Sensitivity', [
        'I was aware of my personal biases while collecting and analyzing data.',
        'I used inclusive and accessible terminology in the questionnaire.',
        'I handled discrete information of the respondents in a confidential and respectful manner.'
      ])}

      {renderCategory('creativity', 'Creativity', [
        'I was able to consider various strategies to collect data from the respondents.',
        'I was able to adjust my approach when needed and address unexpected challenges.',
        'I was able to explore various ways to present my findings and recommendations in an engaging way.'
      ])}

      {/* Stick figure with speech bubble and text area */}
      <div style={{ display: 'flex', gap: '15px', alignItems: 'center', marginBottom: '15px' }}>
        {/* Stick figure with speech bubble */}
        <div style={{ flexShrink: 0, textAlign: 'center' }}>
          {/* Speech bubble */}
          <div style={{
            backgroundColor: 'white',
            border: '2px solid black',
            borderRadius: '15px',
            padding: '10px 15px',
            fontSize: '15px',
            lineHeight: '1.3',
            maxWidth: '140px',
            marginBottom: '8px',
            textAlign: 'center',
            position: 'relative'
          }}>
            Leave some words of appreciation/ encouragement for yourself.
            {/* Speech bubble pointer */}
            <div style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '8px solid transparent',
              borderRight: '8px solid transparent',
              borderTop: '10px solid black'
            }} />
            <div style={{
              position: 'absolute',
              bottom: '-6px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '6px solid transparent',
              borderRight: '6px solid transparent',
              borderTop: '8px solid white'
            }} />
          </div>
          {/* Stick figure */}
          <svg width="60" height="80" viewBox="0 0 60 80" style={{ display: 'block', margin: '0 auto' }}>
            {/* Head */}
            <circle cx="30" cy="15" r="12" stroke="black" strokeWidth="2" fill="white" />
            {/* Body */}
            <line x1="30" y1="27" x2="30" y2="50" stroke="black" strokeWidth="2" />
            {/* Arms */}
            <line x1="30" y1="35" x2="15" y2="45" stroke="black" strokeWidth="2" />
            <line x1="30" y1="35" x2="45" y2="45" stroke="black" strokeWidth="2" />
            {/* Legs */}
            <line x1="30" y1="50" x2="20" y2="70" stroke="black" strokeWidth="2" />
            <line x1="30" y1="50" x2="40" y2="70" stroke="black" strokeWidth="2" />
          </svg>
        </div>

        {/* Text area */}
        <div style={{ flex: 1 }}>
          <textarea
            value={formData.self_appreciation}
            onChange={(e) => handleFieldChange('self_appreciation', e.target.value)}
            placeholder="Write your words of self-appreciation and encouragement..."
            style={{
              width: '100%',
              padding: '12px 15px',
              fontSize: '14px',
              minHeight: '140px',
              backgroundColor: '#B3D9E8',
              border: 'none',
              borderRadius: '15px',
              lineHeight: '1.4',
              fontFamily: "'Poppins', Arial, sans-serif",
              resize: 'vertical',
              boxSizing: 'border-box'
            }}
          />
        </div>
      </div>



    </div>
  );
};

export default PartCPage6;
